export default "https://cdn-gra.amplement.io/statics/images/file/file-ppt.svg";